import client, { builder } from "utils/graphql";
import { IDefinition } from "types/utils/graphql";
import { isNull, get, set, omit } from "utils/lodash";
import helper from "utils/helper";
import { match } from "utils/renderPropsComposer";
export default class BaseService {
  name: any;
  collection: any;
  static DEFINITION: IDefinition;
  getBaseQuery(selections: string) {
    const defs = (this.constructor as typeof BaseService).DEFINITION;

    return builder.getBaseQuery(selections, defs);
  }
  getFindQuery(selections: string) {
    const defs = (this.constructor as typeof BaseService).DEFINITION;
    return builder.getFindQuery(selections, defs);
  }
  getUpdateQuery(selections: string) {
    const defs = (this.constructor as typeof BaseService).DEFINITION;
    return builder.getUpdateQuery(selections, defs);
  }
  getCreateQuery(selections: string) {
    const defs = (this.constructor as typeof BaseService).DEFINITION;
    return builder.getCreateQuery(selections, defs);
  }
  getDeleteQuery(selections: string) {
    const defs = (this.constructor as typeof BaseService).DEFINITION;
    return builder.getDeleteQuery(selections, defs);
  }
  getCustomGQL(query: string) {
    return builder.getCustomGQL(query);
  }

  buildOptions(options: any = {}) {
    const normalizedOptions = helper.normalizeParams(options);
    let result = {
      ...(get(options, "fetchPolicy") && {
        fetchPolicy: get(options, "fetchPolicy"),
      }),
    };
    if (!!normalizedOptions.token) {
      set(
        result,
        "context.headers.Authorization",
        `Bearer ${normalizedOptions.token}`
      );
      result = omit(result, "token");
    }
    if (
      !normalizedOptions.variables &&
      !!omit(options, ["token", "fetchPolicy", "log"])
    ) {
      set(result, "variables", {
        ...omit(options, ["token", "fetchPolicy", "log"]),
      });
    }
    return result;
  }
  pickParams(params: any) {
    const result = {
      total: get(params, "totalDocs"),
      totalPage: get(params, "totalPages"),
      limit: get(params, "limit"),
      page: get(params, "page"),
      offset: get(params, "offset"),
    };

    return result;
  }
  handleCustomResponse(res: any, paths: object) {
    let result = res;
    const path = get(paths, `DATA`);
    const pathParams = get(paths, `PARAMS`);
    const pathError = get(paths, `ERRORS`);
    if (!!pathParams)
      result = { ...result, params: this.pickParams(get(res, pathParams)) };
    if (!!path && !!get(result, path))
      result = { ...result, data: get(res, path) };
    if (!!pathError && !!get(result, pathError))
      result = { ...result, errors: get(res, pathError) };
    return result;
  }
  handleResponse(res: any, gqlAction: string) {
    let result = res;
    const defs = (this.constructor as typeof BaseService).DEFINITION;
    const path = get(defs, `GQL_RESPONSE_DATA_PATH.${gqlAction}`);
    const pathParams = get(defs, `GQL_RESPONSE_DATA_PATH.PARAMS`);
    if (!!pathParams)
      result = { ...result, params: this.pickParams(get(res, pathParams)) };
    if (!!path && !!get(result, path))
      result = { ...result, data: get(res, path) };
    return result;
  }
  async id(id: string, selections: string = "") {
    const query = this.getBaseQuery(selections);
    if (isNull(query)) return false;
    return this.handleResponse(
      await client.query({ query, variables: { id } }),
      "BASE"
    );
  }
  async find(options: any = {}, selections: string = "") {
    const defs = (this.constructor as typeof BaseService).DEFINITION;
    const query = this.getFindQuery(selections);
    if (isNull(query)) return false;
    const opts = this.buildOptions(options);
    console.log("opts", opts);
    return this.handleResponse(await client.query({ query, ...opts }), "FIND");
  }
  async create(options: any = {}, selections: string = "") {
    const defs = (this.constructor as typeof BaseService).DEFINITION;
    const query = this.getCreateQuery(selections);
    if (isNull(query)) return false;
    const opts = this.buildOptions(options);
    return this.handleResponse(
      await client.mutate({ mutation: query, ...opts }),
      "CREATE"
    );
  }
  async update(options: any = {}, selections: string = "") {
    const query = this.getUpdateQuery(selections);
    console.log("query", query);
    if (isNull(query)) return false;
    const opts = this.buildOptions(options);
    return this.handleResponse(
      await client.mutate({ mutation: query, ...opts }),
      "UPDATE"
    );
  }
  async delete(options: any = {}, selections: string = "") {
    const query = this.getDeleteQuery(selections);
    if (isNull(query)) return false;
    const opts = this.buildOptions(options);
    // console.log("opts", opts);
    return this.handleResponse(
      await client.mutate({ mutation: query, ...opts }),
      "DELETE"
    );
  }
  async custom(options: any = {}, customQuery: string) {
    const log = get(options, "log", false);

    const query = this.getCustomGQL(customQuery);

    if (isNull(query)) return false;
    const { typeQL = "query", PATH_RESPONSE = {}, ...customOptions } = options;
    const opts = this.buildOptions(customOptions);
    if (log) {
      console.log("query", customQuery);
      console.log("opts", opts);
    }
    const resultCustomResponse = // console.log("customQuery", customQuery, { opts });
      this.handleCustomResponse(
        await match(
          {
            isTrue: typeQL === "mutation",
            value: async () => {
              try {
                console.log("mutation: ", { mutation: query, ...opts });
                return await client.mutate({ mutation: query, ...opts });
              } catch (errors) {
                return { errors };
              }
            },
          },
          {
            isTrue: typeQL === "query",
            value: async () => {
              try {
                return await client.query({ query, ...opts });
              } catch (errors) {
                return { errors };
              }
            },
          }
        )(),
        PATH_RESPONSE
      );
    // console.log("resultCustomResponse", resultCustomResponse);
    return resultCustomResponse;
  }
}
